module.exports = __webpack_public_path__ + "static/media/header-image.4db1849b.png";